import React from "react";
import Status from "./Status";
import "./TokenPot.css";
const TokenPot = ({ isLive, name, img, index, onEdit, onSwitchStatus }) => {
  return (
    <div className="token-pot-container">
      <p className="title">Token Pot {index + 1}</p>
      <div
        className="pot-icon"
        style={{ backgroundImage: `url(${img})` }}
      ></div>
      <p className="name">{name || "Name"} Token</p>
      <Status
        onSwitchStatus={onSwitchStatus}
        isLive={isLive}
        dataTarget="#token-pot-modal"
        onEdit={onEdit}
      />
    </div>
  );
};

export default TokenPot;



// WEBPACK FOOTER //
// ./src/screens/TokensAndPots/TokenPot.js